<template>
  <div class="activation-code-detail">
    <div class="header-back" @click="$router.go(-1)">返回 ></div>
    <CommonTable
      tableType="激活码使用详情"
      :count="count"
      :keys="codeKeys"
      :list="codeList"
      @changePagingParams="changePagingParams"
    >
      <template v-slot:table-filter>
        <div class="slot-box">
          <div class="slot-box-left">
            <SelectCom
              placeholder="请选择激活码状态"
              v-model="filterParams.status"
              :options="statusList"
            />
            <CommonInput
              v-model="filterParams.username"
              placeholder="按账号名搜索"
            />
          </div>
          <div class="slot-box-right">
            <el-button type="primary" @click="download">导出</el-button>
          </div>
        </div>
      </template>
    </CommonTable>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import { exportXlsx } from '@/utils/common'
import CommonTable from '../common/CommonTable'
import SelectCom from '../common/SelectCom'
import CommonInput from '../common/CommonInput'

export default {
  name: 'ActivationCodeDetail',
  components: {
    CommonTable,
    SelectCom,
    CommonInput,
  },
  data() {
    return {
      filterParams: {
        status: '',
        username: '',
        page: 1,
        pageSize: 10,
      },
      statusList: [
        {
          value: 0,
          label: '未激活',
        },
        {
          value: 1,
          label: '已激活',
        },
        {
          value: 2,
          label: '已无效',
        },
      ],
      codeKeys: [
        {
          prop: 'key',
          label: '激活码',
        },
        {
          prop: 'title',
          label: '标题',
        },
        {
          prop: 'useTime',
          label: '使用时限',
        },
        {
          prop: 'createdAt',
          label: '创建时间',
        },
        {
          prop: 'status',
          label: '激活状态',
        },
        {
          prop: 'schoolName',
          label: '学校',
        },
        {
          prop: 'activateUser',
          label: '激活账号',
        },
        {
          prop: 'activateTime',
          label: '激活时间',
        },
      ],
      count: 0,
      codeList: [],
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    },
    useTime() {
      return this.$route.query.useTime
    },
    title() {
      return this.$route.query.title
    },
  },
  watch: {
    filterParams: {
      deep: true,
      handler() {
        this.debounce()
      },
    },
  },
  created() {
    this.onGetActivateCodeDetail()
  },
  methods: {
    ...mapActions({
      getActivateCodeDetail: 'newStat/getActivateCodeDetail',
    }),
    debounce: _.debounce(function () {
      this.onGetActivateCodeDetail()
    }, 300),
    async onGetActivateCodeDetail() {
      const { count, rows } = await this.onGetActivateCodeDetailFunc()
      this.count = count
      this.codeList = rows
    },
    async onGetActivateCodeDetailFunc() {
      const params = {
        id: this.$route.query.id,
        'x-page': this.filterParams.page,
        'x-per-page': this.filterParams.pageSize,
      }
      if (this.filterParams.status !== '') {
        params.status = this.filterParams.status
      }
      if (this.filterParams.username) {
        params.username = this.filterParams.username
      }
      const { count, rows } = await this.getActivateCodeDetail(params)
      const codeList = rows.map(item => {
        const curStatus = this.statusList.find(ele => ele.value === item.status)
        return {
          key: item.key.replace(/(.{4})/g, '$1 '),
          title: this.title,
          useTime: this.useTime,
          status: curStatus && curStatus.label,
          createdAt: moment(item.createdAt).format('YYYY-MM-DD HH:mm'),
          activateTime:
            item.activateTime &&
            moment(item.activateTime).format('YYYY-MM-DD HH:mm'),
          activateUser: item.username,
          schoolName: item.schoolName,
        }
      })
      return {
        count,
        rows: codeList,
      }
    },
    async download() {
      const { rows } = await this.onGetActivateCodeDetailFunc(true)
      if (rows.length > 0) {
        exportXlsx('激活码使用列表', this.codeKeys, rows)
      } else {
        this.$message.warning('暂时没有数据')
      }
    },
    changePagingParams(paging) {
      this.filterParams = {
        ...this.filterParams,
        ...paging,
      }
    },
  },
}
</script>

<style lang='scss'>
.activation-code-detail {
  position: relative;
  .header-back {
    position: absolute;
    right: 20px;
    top: 10px;
    color: #999;
    padding: 4px;
    cursor: pointer;
    &:hover {
      color: #2397f3;
    }
  }
}
</style>